import { render } from "./inbc2.vue?vue&type=template&id=1525f2a0&scoped=true"
import script from "./inbc2.vue?vue&type=script&lang=js"
export * from "./inbc2.vue?vue&type=script&lang=js"

import "./inbc2.vue?vue&type=style&index=0&id=1525f2a0&lang=less&scoped=true"
import "./inbc2.vue?vue&type=style&index=1&id=1525f2a0&scoped=true&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1525f2a0"]])

export default __exports__